import { render, staticRenderFns } from "./contact-information.vue?vue&type=template&id=e2f28fe4"
import script from "./contact-information.vue?vue&type=script&lang=ts"
export * from "./contact-information.vue?vue&type=script&lang=ts"
import style0 from "./contact-information.vue?vue&type=style&index=0&id=e2f28fe4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports